"use client";

import { useEffect } from "react";

import SignIn from "@/components/header/SignIn";

interface Props {
  aoBaseUrl: string;
  accountUrl: string;
    subscriptionType?: string;
}

const Header = ({ aoBaseUrl, accountUrl, subscriptionType }: Props) => {
  const loadDigitalData = async () => {
    const digitalData = await import("@aoworld-aotech/digital-data");
    return digitalData.captureGlobalEvents;
  };

  useEffect(() => {
    const body = document.querySelector("body");

    if (!body) return;

    loadDigitalData().then((capture) => {
      capture(body);
    });
  }, []);

  return (
    <header
      className="border-b-4 border-solid border-ongreen"
      data-tag-section={`subscriptions ${subscriptionType} header`}
    >
      <div className="mx-4 xxl:mx-auto my-1 flex justify-between items-center max-w-[1440px]">
        <div
          className="text-ongreen text-5xl lg:text-[4rem]"
          role="img"
          aria-label="AO Logo"
          data-tag-name="AO Logo"
        >
          <a href={`${aoBaseUrl}`}>
            <i className="ico ico-ao-logo lg:-ml-1"></i>
          </a>
        </div>
        <SignIn accountUrl={accountUrl} />
      </div>
    </header>
  );
};

export default Header;
